jQuery(function($){
	var $titleTab = $('.title_tab');
	// $('.accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
	// $('.accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
	$titleTab.on('click', function(e) {
	e.preventDefault();
		if ( $(this).hasClass('active') ) {
			$(this).removeClass('active');
			$(this).next().stop().slideUp(500);
			$(this).next().find('.inner_content_text').removeClass('show');
		} else {
			$(this).addClass('active');
			$(this).next().stop().slideDown(500);
			$(this).parent().siblings().children('.title_tab').removeClass('active');
			$(this).parent().siblings().children('.inner_content').slideUp(500);
			$(this).parent().siblings().children('.inner_content').find('.inner_content_text').removeClass('show');
			$(this).next().find('.inner_content_text').addClass('show');
            // jQuery("html, body").animate({scrollTop: $(this).offset().top -  100}, "fast");
		}
	});
});